import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  reviewdetailsSelector,
  cabDetailsSelector,
  reasonSelector,
  loaderSelector,
  reviewPopupSelector,
  sourceDestinationSelector,
  reviewRatingDataSelector,
  caSelector,
  driverProfileSelector,
  easyBoardingSelector,
  isAirportTripSelector,
  cabImagesSelector,
  flagsInfoSelector,
  dbgDetailsSelector,
  isLoggedInSelector,
  supplierNameSelector
} from "../../redux/selector";
import { fetchBlockApi, fetchReview } from "../../redux/thunks";
import * as S from "./ReviewDetails.styles";
import ReviewCabDetailsUI from "../../../../../stories/components/cars/reviewpage/ReviewCabDetails/ReviewCabDetailsUI";
import CabDriverDetailsUI from "../../../../../stories/components/cars/reviewpage/CabDriverDetails/CabDriverDetailsUI";
import PaymentOffers from "../PaymentOffers/PaymentOffers";
import ReviewItems from "../ReviewItems/ReviewItems";
import Reason from "../../../../../stories/components/cars/reviewpage/Reasons/ReasonsUI";
import PaymentLoaderUI from "../../../../../stories/components/cars/reviewpage/PaymentLoader/PaymentLoaderUI";
import ReviewLoaderUI from "../../../../../stories/components/cars/reviewpage/ReviewLoader/ReviewLoaderUI";
import ReviewPopup from "../../../../../stories/components/cars/ResultsPage/Review-popup/Review-popupUI";
import useNavigate from "../../../../../shared/hooks/useNavigate";
import { scrollToTop } from "../../../../config/utils";
import ReviewRatingUI from "../../../../../stories/components/cars/ResultsPage/ReviewRating/ReviewRatingUI";
import DriverProfileUI from "../../../../../stories/components/cars/reviewpage/DriverProfile/DriverProfileUI";
import EasyBoardingUI from "../../../../..//stories/components/cars/reviewpage/EasyBoarding/EasyBoardingUI";
import CabImagesCarousel from "../../../../..//stories/components/cars/reviewpage/CabImages/CabImages";
import ReviewRating from "../ReviewRating/ReviewRating";
import { CTA_TYPE, getActionNameForOmniture } from "../../../../../shared/utils/omni-utils";
import { gcBookingReviewScreen, pushCtaOmniEvents } from "../../../../../shared/config/omni"
import { getLoadedComponent } from "../../../../../shared/config/omni";
import { CAB_VARIANT_IMAGES, CABS_REVIEW_ROUTE, CABS_REVIEW_PAGE, CAB_IMAGE_TYPE, VIEW_ALL_REVIEWS, LOBNAME, MOB_CABS_REVIEW, GO_TRIBE_INLINE_CARD_SHOWN, GO_TRIBE_INLINE_CARD_NOT_SHOWN, OW, RT } from "../../../../../shared/utils/util-constants";
import ListingLoadingUI from "../../../../../stories/components/cars/ResultsPage/ListingLoading/ListingLoadingUI";
import { GoTribeReview } from '@growth/gotribe/goTribeReview';
import { UPDATE_LOADER_STATE, UPDATE_POPUP_RESPONSE } from "../../redux/action-types";
import SavaariBanner from "../../../../../shared/components/SavaariBanner";
import { savaariBannerSelector, tripTypeSelector } from "../../../../../shared/common/redux/selector";
import { SAVAARI } from "../../../../../shared/config/constants";

enum IMAGE_REVIEW_CLICK {
  IMAGE_CLICK = "IMAGE_CLICK",
  REVIEW_CLICK = "REVIEW_CLICK"
}

const ReviewDetails = () => {
  const [showReviewRating, setShowReviewRating] = useState(false);

  const reviewDetails     = useSelector(reviewdetailsSelector);
  const cabDetails        = useSelector(cabDetailsSelector);
  const reasons           = useSelector(reasonSelector);
  const loaders           = useSelector(loaderSelector);
  const popup             = useSelector(reviewPopupSelector);
  const sourceDestination = useSelector(sourceDestinationSelector);
  const reviewRatingData  = useSelector(reviewRatingDataSelector);
  const driverProfileData = useSelector(driverProfileSelector);
  const caData            = useSelector(caSelector);
  const easyBoarding      = useSelector(easyBoardingSelector);
  const isAirportTrip     = useSelector(isAirportTripSelector);
  const cabImagesData     = useSelector(cabImagesSelector);
  const flagInfo          = useSelector(flagsInfoSelector)
  const dbgData           = useSelector(dbgDetailsSelector)
  const isLoggedIn        = useSelector(isLoggedInSelector);
  const savaariBannerInfo = useSelector(savaariBannerSelector);
  const supplierName      = useSelector(supplierNameSelector);
  const tripType          = useSelector(tripTypeSelector);

  const billingDetailsRef = useRef(null);

  const dispatch = useDispatch();
  const [navigateTo] = useNavigate();
  const { review = true, pay = true } = loaders;

  useEffect(() => {
    getLoadedComponent('ReviewDetails')
  }, [])

  useEffect(() => {
    if (!review && !(reviewDetails?.goTribeInlineData && Object.keys(reviewDetails?.goTribeInlineData).length)) {
      pushCtaOmniEvents(`${MOB_CABS_REVIEW}_${GO_TRIBE_INLINE_CARD_NOT_SHOWN}`, CTA_TYPE.HYPER_LINK, CABS_REVIEW_PAGE, CABS_REVIEW_ROUTE)
    }
  }, [review, reviewDetails?.goTribeInlineData])
  
  const updateInfo = useCallback(
    (action) => {
      dispatch({
        type: "UPDATE_RECENT_SEARCH",
        data: sourceDestination,
      });
      dispatch({
        type: UPDATE_POPUP_RESPONSE,
        popup: {}
      });
      switch (action) {
        case "HOME":
        case "REVIEW_TIMELESS":
        case "SRP_TIMELESS":
          dispatch({
            type: "UPDATE_LOADER",
          });
          dispatch({
            type: UPDATE_LOADER_STATE,
            loaders: {
              review: true,
              pay: true,
            },
          });
          navigateTo("home")
          break;
        case "SRP":
          navigateTo("srp");
          break;
        case "REVIEW":
          dispatch(fetchReview(false));
          break;
        case "TRAVELLER_DETAILS":
          scrollToTop(900);
          break;
        default:
          break;
      }
    },
    [dispatch, sourceDestination]
  );

  const onBillingDetailsSuccess = (data) => {
    if (isLoggedIn) dispatch(fetchBlockApi())
    else dispatch(fetchBlockApi(data))
  }

  const sendOmniEvents = (clickType : IMAGE_REVIEW_CLICK) => {
    const name : string = clickType === IMAGE_REVIEW_CLICK.REVIEW_CLICK ? VIEW_ALL_REVIEWS : CAB_VARIANT_IMAGES
    const type : CTA_TYPE = clickType === IMAGE_REVIEW_CLICK.REVIEW_CLICK ? CTA_TYPE.HYPER_LINK : CTA_TYPE.IMAGES
    pushCtaOmniEvents(getActionNameForOmniture(gcBookingReviewScreen, name) , type, CABS_REVIEW_PAGE, CABS_REVIEW_ROUTE)
  }
  
  return (
    <>
      <S.ReviewWrapper>
        {loaders?.isBlockapi ? (
          <ListingLoadingUI loadingText={"Finalizing Your Ride... Almost there!"} />) 
        : null}
        <S.ReviewWrapperLeft>
          
          {!review ? (
            <>
              <S.BoxContainer
                bgColor="#fff"
                borderRadius="0.4rem"
                margin="0 0 1.5rem 0"
              >
                <S.BoxContainer
                  borderRadius="0.4rem"
                  shadow="0 0.2rem 0.6rem 0 rgba(203, 203, 203, 0.5);"
                  padding="2.5rem 3rem"
                >
                  <ReviewCabDetailsUI {...reviewDetails} caData={caData} />
                  <Reason {...reasons} isBluSmart={flagInfo?.BLU} h={reviewDetails?.h}/>
                </S.BoxContainer>
                {Object.keys(cabDetails)?.length ? (
                  <S.BoxContainer
                    borderRadius="0 0 0.4rem 0.4rem"
                    padding="2.5rem 3rem"
                  >
                    <CabDriverDetailsUI margin="0 0 1rem 0" {...cabDetails} />
                    {!!isAirportTrip ? <EasyBoardingUI margin="4rem 0 1rem" {...easyBoarding} /> : null}
                    <CabImagesCarousel onIncrementDecrement={() => sendOmniEvents(IMAGE_REVIEW_CLICK.IMAGE_CLICK)} onImageTabSelect={(key) => {
                      pushCtaOmniEvents(getActionNameForOmniture(gcBookingReviewScreen, `${CAB_IMAGE_TYPE}_${key}`), CTA_TYPE.HYPER_LINK, CABS_REVIEW_PAGE, CABS_REVIEW_ROUTE)
                    }} {...cabImagesData} />
                    <DriverProfileUI margin="2rem 0 0 0" {...driverProfileData} />
                    {!!reviewRatingData?.t ? <S.RvCont>
                      <h4>{reviewRatingData?.t}</h4>
                      <div className="makeFlex">
                        <ReviewRatingUI data={reviewRatingData} margin="0 0 0 0" />
                      </div>
                      {!!reviewRatingData?.r_u && <p className="viewAll" onClick={
                        () => {
                          sendOmniEvents(IMAGE_REVIEW_CLICK.REVIEW_CLICK)
                          setShowReviewRating(true)
                      }}>
                        View all reviews
                      </p>}
                    </S.RvCont> : null}
                  </S.BoxContainer>
                ) : null}
              </S.BoxContainer>
              {((tripType?.rf === OW || tripType?.rf === RT) && supplierName?.toLowerCase() === SAVAARI) &&
                <SavaariBanner data={savaariBannerInfo} isReview={true}/>
              }
              {reviewDetails?.goTribeInlineData && Object.keys(reviewDetails?.goTribeInlineData).length ? (
                <S.GoTribeCont>
                  <GoTribeReview
                    header={reviewDetails?.goTribeInlineData?.data?.header}
                    subHeader={reviewDetails?.goTribeInlineData?.data?.subHeader}
                    imageUrl ={reviewDetails?.goTribeInlineData?.data?.imageUrl}
                    benefits={reviewDetails?.goTribeInlineData?.data?.benefits}
                    tier={reviewDetails?.goTribeInlineData?.goTribeTier}
                    lob={LOBNAME}
                    isMobile={false}
                    cardId={reviewDetails?.goTribeInlineData?.cardId}
                    onLoad={() => {
                      pushCtaOmniEvents(`${MOB_CABS_REVIEW}_${GO_TRIBE_INLINE_CARD_SHOWN}`, CTA_TYPE.HYPER_LINK, CABS_REVIEW_PAGE, CABS_REVIEW_ROUTE)
                    }}
                  />
                </S.GoTribeCont>
              ) : null}
              <ReviewItems billingDetailsRef={billingDetailsRef} onBillingDetailsSuccess={onBillingDetailsSuccess}/>
            </>
          ) : (
            <ReviewLoaderUI />
          )}
        </S.ReviewWrapperLeft>
        <S.ReviewWrapperRight>
          {!pay ? <PaymentOffers billingDetailsRef={billingDetailsRef}/> : <PaymentLoaderUI />}
        </S.ReviewWrapperRight>
        <ReviewPopup {...popup} updateInfo={updateInfo} />
        {showReviewRating && <ReviewRating onClose={() => setShowReviewRating(false)} />}
      </S.ReviewWrapper>
    </>
  );
};

export default React.memo(ReviewDetails);
